var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import reactMapboxGl from 'react-mapbox-gl';
import { CardContent } from 'material-ui';
import { CustomCard } from '../CustomCard';
import { LngLat, LngLatBounds } from 'mapbox-gl';
import Vehicle from './Vehicle';
import Line from './Line';
import Stops from './Stops';
import { connect } from 'react-redux';
import 'rc-slider/assets/index.css';
import TestLine from './TestLine';
import TestModeDependentContainer from '../../containers/TestModeDependentContainer';
var Map = reactMapboxGl({
    accessToken: 'pk.eyJ1IjoiZmxha3RhY2siLCJhIjoiMnZVbHZUdyJ9.bT9VCItKTzFObNF0Dfg68Q',
});
var CONTAINER_STYLE = {
    height: 'calc(100vh - 24px - 40px - 40px)',
    width: '100%',
};
var FIT_BOUNDS_OPTIONS = { padding: 20 };
var NO_TRIP_STATE = {
    fitBounds: void 0,
    firstZoom: true,
    stopCoords: [],
    lineCoords: [],
};
var MapControl = /** @class */ (function (_super) {
    __extends(MapControl, _super);
    function MapControl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = NO_TRIP_STATE;
        return _this;
    }
    MapControl.prototype.componentWillReceiveProps = function (newProps) {
        var bounds = new LngLatBounds();
        if (newProps.location) {
            bounds.extend(new LngLat(newProps.location.longitude, newProps.location.latitude));
        }
        var trip = newProps.trip;
        if (trip === null) {
            if (this.state.firstZoom) {
                this.setState({
                    fitBounds: bounds.toArray(),
                    firstZoom: false,
                    stopCoords: [],
                    lineCoords: [],
                });
            }
            else if (this.props.trip) {
                this.setState({
                    fitBounds: void 0,
                    firstZoom: false,
                    stopCoords: [],
                    lineCoords: [],
                });
            }
            return;
        }
        if (trip === this.props.trip) {
            return;
        }
        var shape = trip.shape;
        var lineCoords = shape.map(function (_a) {
            var lon = _a.lon, lat = _a.lat;
            return [lon, lat];
        });
        var stopCoords = trip.stops.map(function (_a) {
            var stopLon = _a.stopLon, stopLat = _a.stopLat;
            return [stopLon, stopLat];
        });
        var fitBounds = lineCoords.reduce(function (bounds, coord) { return bounds.extend(new LngLat(coord[0], coord[1])); }, bounds).toArray();
        this.setState({
            firstZoom: false,
            fitBounds: fitBounds,
            stopCoords: stopCoords,
            lineCoords: lineCoords,
        });
    };
    MapControl.prototype.render = function () {
        var _a = this.props, scenario = _a.scenario, scenarioStatus = _a.scenarioStatus;
        var lastOffset = scenarioStatus ? scenarioStatus.lastOffset : 0;
        return (React.createElement(CustomCard, null,
            React.createElement(CardContent, { style: { padding: '0px' } },
                React.createElement(Map, { fitBounds: this.state.fitBounds, fitBoundsOptions: FIT_BOUNDS_OPTIONS, style: "mapbox://styles/mapbox/light-v9", containerStyle: CONTAINER_STYLE },
                    React.createElement(Line, { coordinates: this.state.lineCoords }),
                    React.createElement(TestModeDependentContainer, { referenceMode: "test_scenario" }, scenario && scenario.events &&
                        React.createElement(TestLine, { testEvents: scenario.events, lastOffset: lastOffset })),
                    React.createElement(Stops, { coordinates: this.state.stopCoords }),
                    React.createElement(Vehicle, null)))));
    };
    return MapControl;
}(React.Component));
export default connect(function (state) { return ({
    trip: state.trip,
    location: state.location,
    scenario: state.scenario,
    scenarioStatus: state.scenarioStatus,
}); })(MapControl);



//////////////////
// WEBPACK FOOTER
// ./src/components/MapControl/index.tsx
// module id = 1729
// module chunks = 0